import React from 'react';

export default function MarketBreadcrumbs({ breadcrumbs, onNavigate }) {
  return (
    <nav className="prospecting-breadcrumbs" aria-label="Położenie na mapie">
      {breadcrumbs.map((crumb, index) => (
        <React.Fragment key={`${crumb.level}-${crumb.id}`}>
          {index > 0 ? <span className="prospecting-breadcrumb-separator">/</span> : null}
          <button type="button" onClick={() => onNavigate(crumb.level, crumb.id)}>
            {crumb.name}
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
}
